<template>
  <TagsContext>
    <RouterView></RouterView>
  </TagsContext>
</template>

<script setup lang="ts">
import TagsContext from '@/components/deepbox/tags/TagsContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.tags',
  },
})
</script>
